const getImage = (id: string) => {
    const image = process.env.REACT_APP_CMS_URL + `/assets/${id}`
    return image
}

export default getImage